import React from 'react';
import { Input, InputProps, MultiSelect, MultiSelectProps } from '@otp/ui';
import { FieldsItemType } from './types';
import { SelectOption } from '@otp/ui/src';
import { LoginRuleUserPoolFieldPayload } from 'src/graphql/generated/graphql';
import { LoginRuleUserPoolFieldsPayload } from '../types';

export const getComponentByType = ({
  type,
  data,
}: {
  type: FieldsItemType;
  data: LoginRuleUserPoolFieldsPayload;
}) => {
  // Memoized components to unnecessary avoid re-renders
  // eslint-disable-next-line react/display-name
  const MemoizedInput = React.memo((props: InputProps) => <Input {...props} />);
  // eslint-disable-next-line react/display-name
  const MemoizedMultiSelect = React.memo(
    (
      props: MultiSelectProps<any, false, true, undefined> & {
        options: SelectOption[];
        fieldName: keyof typeof data;
        isRequired?: boolean;
      },
    ) => {
      const options = data[props.fieldName]
        ? (data[props.fieldName] as LoginRuleUserPoolFieldPayload[])?.map(
            (item) => {
              return {
                value: item.id as string,
                name: item.name as string,
              };
            },
          )
        : [];
      const isRequired = props.isRequired;

      return (
        <MultiSelect
          {...props}
          multiple={false}
          fullWidth
          options={options}
          disableClearable={!!isRequired as any}
        />
      );
    },
  );

  switch (type) {
    case FieldsItemType.Input:
      return MemoizedInput;
    case FieldsItemType.Select: {
      return MemoizedMultiSelect;
    }
    default:
      return null;
  }
};
